<template>
  <div id="nftInfo">
    <MediumView v-if="type === 'medium'" />
    <SmallView v-else-if="type === 'small'" />
    <MiniView v-else-if="type === 'mini'" />
  </div>
</template>

<script>
import MediumView from "./childrens/medium.vue";
import SmallView from "./childrens/small.vue";
import MiniView from "./childrens/mini.vue";

export default {
  name: "NftInfo",
  components: { MediumView, SmallView, MiniView },
  props: ["type"],
};
</script>
